import React, {memo, useState} from "react";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {cloneDeep} from "lodash";

import AutoForm from "../Forms/AutoForm";
import Loader from "../../components/Loader";

const EthernetConfig = (props) => {
  const {open, configObj, onClose, onSubmit} = props;

  const [ethernetConfig, setEthernetConfig] = useState(configObj);

  const inputHandler = (event) => {
    const {accessKey, checked, value, type} = event.target;

    const formattedConfigObject = cloneDeep(ethernetConfig);

    formattedConfigObject[parseInt(accessKey)].field_value =
      type === "checkbox" ? checked : value;

    setEthernetConfig(formattedConfigObject);
  };

  const formattedFieldDefinition = ethernetConfig.filter((field) => {
    let isVisible = false;
    if (!field.depend_field_definition) {
      isVisible = true;
    } else {
      const findDependant = ethernetConfig.find(
        (dependantField) => dependantField.slug === field.depend_field_definition
      );

      if (field.depend_field_value === findDependant?.field_value) {
        isVisible = true;
      }
    }
    return isVisible;
  });

  const onUpdate = () => {
    onSubmit(formattedFieldDefinition);
  };

  return (
    <>
      <Modal unmountOnClose={true} isOpen={open} backdrop={"static"}>
        <Loader />
        <ModalHeader>{ethernetConfig.name}</ModalHeader>
        <ModalBody>
          <>
            {/* <label>{name}</label> */}
            {/* <hr /> */}
            <AutoForm
              formArray={formattedFieldDefinition}
              title={""}
              inputChangeHandler={inputHandler}
            />
          </>
        </ModalBody>
        <ModalFooter>
          <Button onClick={onUpdate} data-cy={"submit-btn"}>
            Update
          </Button>
          <Button onClick={onClose}>Cancel</Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

function areEqual() {}

export default memo(EthernetConfig, areEqual);
